import { Box, Heading } from '@wix/design-system';
import { Faq as PlatformFaq } from '@wix/premium-purchase-platform/@components';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { useIsStudioNewUi, useRevShare } from '../../hooks';
import { STUDIO_CARD_BORDER_COLOR } from '../../utils/consts';
import { useCurrentModule } from '../ModuleProvider';
import s from './Faq.scss';
const newUiItemBoxProps = {
  className: s.item,
  borderBottom: `1px solid ${STUDIO_CARD_BORDER_COLOR}`
};
export const Faq = _ref => {
  let {
    t,
    Trans,
    background
  } = _ref;
  const module = useCurrentModule();
  const {
    utils
  } = PlatformFaq.useFaq({
    componentName: 'Faq'
  });
  const {
    hasRevShare,
    isLoading
  } = useRevShare();
  const isStudioNewUi = useIsStudioNewUi();
  const platformContext = PremiumPurchasePlatformModule.internals.useContext();
  const renderWithParams = content => utils.renderWithParams(Trans, t, content);
  if (isLoading) {
    return null;
  }
  const faq = /*#__PURE__*/React.createElement(PlatformFaq.Root, {
    background: isStudioNewUi ? 'transparent' : background,
    useLoader: true,
    onActionClick: event => {
      module.internals.bi.onFaqLinkClick == null || module.internals.bi.onFaqLinkClick({
        event
      });
    }
  }, _ref2 => {
    var _data$items, _data$title2;
    let {
      data
    } = _ref2;
    const content = /*#__PURE__*/React.createElement(PlatformFaq.Content, null, (_data$items = data.items) == null ? void 0 : _data$items.map((item, idx) => {
      var _item$question2;
      return /*#__PURE__*/React.createElement(PlatformFaq.Item, {
        key: idx,
        onItemClick: _ref3 => {
          var _item$question;
          let {
            action
          } = _ref3;
          module.internals.bi.onFaqItemClick == null || module.internals.bi.onFaqItemClick({
            action,
            questionKey: (_item$question = item.question) == null ? void 0 : _item$question.translationKey
          });
        },
        question: t(((_item$question2 = item.question) == null ? void 0 : _item$question2.translationKey) ?? ''),
        answer: renderWithParams(item.answer),
        boxProps: isStudioNewUi ? newUiItemBoxProps : undefined,
        questionBoxProps: isStudioNewUi ? {
          className: s.question
        } : undefined
      });
    }));
    if (isStudioNewUi) {
      var _data$title;
      return /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: "40px",
        width: "100%",
        className: s.body
      }, /*#__PURE__*/React.createElement(Box, {
        width: "100%",
        align: "space-between",
        verticalAlign: "top",
        className: s.header
      }, /*#__PURE__*/React.createElement(PlatformFaq.Header, null, /*#__PURE__*/React.createElement(Heading, {
        size: "extraLarge",
        className: s.title
      }, t(((_data$title = data.title) == null ? void 0 : _data$title.translationKey) ?? ''))), /*#__PURE__*/React.createElement(PlatformFaq.Subtitle, {
        className: s.subtitle
      }, renderWithParams(data.subtitle))), content);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlatformFaq.Header, null, /*#__PURE__*/React.createElement(PlatformFaq.Title, null, t(((_data$title2 = data.title) == null ? void 0 : _data$title2.translationKey) ?? '')), /*#__PURE__*/React.createElement(PlatformFaq.Subtitle, null, renderWithParams(data.subtitle))), content);
  });
  return /*#__PURE__*/React.createElement(PremiumPurchasePlatformModule.Provider, {
    context: {
      ...platformContext,
      purchaseContext: {
        ...platformContext.purchaseContext,
        params: {
          revShare: hasRevShare
        }
      }
    }
  }, isStudioNewUi ? /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    borderRadius: "12px",
    background: background,
    className: s.newUiFaq
  }, faq) : faq);
};
//# sourceMappingURL=Faq.js.map